"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIconContext = exports.IconDirectionContextProvider = void 0;
var index_1 = require("./contexts/index");
Object.defineProperty(exports, "IconDirectionContextProvider", { enumerable: true, get: function () { return index_1.IconDirectionContextProvider; } });
Object.defineProperty(exports, "useIconContext", { enumerable: true, get: function () { return index_1.useIconContext; } });
